"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dGitProfile = void 0;
exports.dGitProfile = {
    name: 'dGitProvider',
    methods: ['clone', 'addremote', 'delremote', 'remotes', 'init', 'status', 'log', 'commit', 'add', 'rm', 'lsfiles', 'readblob', 'resolveref', 'branch', 'branches', 'checkout', 'currentbranch', 'zip', 'push', 'pull', 'setIpfsConfig', 'getItem', 'setItem', 'localStorageUsed']
};
//# sourceMappingURL=profile.js.map